// @ts-nocheck

/* eslint-disable class-methods-use-this */

/* eslint-disable object-curly-spacing */

/* eslint-disable arrow-body-style */
// eslint-disable-line
import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Col,
  FormControl,
  FormGroup,
  Grid,
  Row,
} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import ReactPixel from 'react-facebook-pixel';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SweetAlert from 'sweetalert-react';

import * as appActions from '../../actions/appActions';
import * as navActions from '../../actions/navActions';
import * as userActions from '../../actions/userActions';
import ThreeDCartLinkModal from './3DCartLinkModal';
import Footer from './Footer';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';
import Section7 from './Section7';
// import RegisterModal from './RegisterModal';
import SectionOne from './SectionOne';

class LandingPageSalesforce extends React.Component {
  constructor(props: any, context: any) {
    super(props, context);

    this.state = {
      regUser: {},
      salesforceStoreUrlValidation: null,
    };

    this.toLogin = this.toLogin.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.testSalesforceCreds = this.testSalesforceCreds.bind(this);
    this.connectWithSalesforce = this.connectWithSalesforce.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  toLogin() {
    this.props.history.push('/login');
  }

  closeModal() {
    // this.setState({ registerModal: false });
    this.props.history.push('/login');
  }

  handleFormChange(event: any) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    const newUser = Object.assign({}, this.state.regUser, { [name]: value });
    this.setState({ regUser: newUser }, () => {
      if (
        this.state.regUser.salesforceClientId &&
        this.state.regUser.salesforceOrganizationId &&
        this.state.regUser.salesforceShortCode &&
        this.state.regUser.salesforceSiteId
      ) {
        this.testSalesforceCreds();
      }
    });
  }

  testSalesforceCreds() {
    this.props.aActions.testSalesforceCreds(
      this.state.regUser,
      (result: any) => {
        if (result && result.success) {
          this.setState({ salesforceStoreUrlValidation: 'success' });
        } else {
          this.setState({ salesforceStoreUrlValidation: 'error' });
        }
      },
    );
  }

  connectWithSalesforce() {
    this.props.nActions.updateSalesforceInfo(this.state.regUser, () => {
      let url = '/login/true?platform=salesforce';
      this.props.history.push(url);
    });
  }

  render() {
    const styles = {
      bigTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '32px',
        lineHeight: '38px',
        letterSpacing: '-0.022em',
        color: '#25252E',
        marginBottom: 20,
        textAlign: 'left',
      },
      title: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '22px',
        letterSpacing: '-0.014em',
        color: '#25252E',
        textAlign: 'left',
        marginBottom: 8,
      },
      searchBox: {
        background: '#FFFFFF',
        border: '1px solid #D7D6DB',
        boxSizing: 'border-box',
        borderRadius: '4px',
        width: '100%',
        height: 50,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '19px',
        letterSpacing: '-0.014em',
        color: '#25252E',
        textAlign: 'left',
      },
      purpleButton: {
        background: '#493EC9',
        borderStyle: 'none',
        borderColor: '#493EC9',
        borderRadius: 4,
        padding: 16,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '800',
        fontSize: '17px',
        lineHeight: '24px',
        textAlign: 'center',
        letterSpacing: '-0.01em',
        color: '#FFFFFF',
        width: '50%',
      },
      purpleButtonDisabled: {
        background: '#a19ce3',
        borderStyle: 'none',
        borderColor: '#a19ce3',
        borderRadius: 4,
        padding: 16,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '800',
        fontSize: '17px',
        lineHeight: '24px',
        textAlign: 'center',
        letterSpacing: '-0.01em',
        color: '#EEEEEE',
        width: '50%',
        cursor: 'not-allowed',
      },
      whiteButton: {
        background: '#ffffff',
        borderStyle: 'solid',
        borderColor: '#D7D6DB',
        borderRadius: 4,
        padding: 16,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '800',
        fontSize: '17px',
        lineHeight: '24px',
        textAlign: 'center',
        letterSpacing: '-0.01em',
        color: '#25252E',
        width: '100%',
      },
      spacerRed: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '28px',
        letterSpacing: '-0.014em',
        color: '#EE3333',
        textAlign: 'center',
      },
    };

    return (
      <div style={{ paddingTop: 150 }} id="landingContainer">
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <h4 style={styles.bigTitle}>
              Enter your Salesforce Commerce API Info
            </h4>
          </Col>
        </Row>

        <div>
          <Row>
            <Col md={{ span: 6, offset: 3 }}>
              <FormControl
                type="text"
                onChange={this.handleFormChange}
                value={this.state.regUser.salesforceClientId}
                style={styles.searchBox}
                name="salesforceClientId"
                placeholder={'Client ID'}
              />
              <FormControl
                type="text"
                onChange={this.handleFormChange}
                value={this.state.regUser.salesforceOrganizationId}
                style={styles.searchBox}
                name="salesforceOrganizationId"
                placeholder={'Organization ID'}
              />
              <FormControl
                type="text"
                onChange={this.handleFormChange}
                value={this.state.regUser.salesforceShortCode}
                style={styles.searchBox}
                name="salesforceShortCode"
                placeholder={'Short Code'}
              />
              <FormControl
                type="text"
                onChange={this.handleFormChange}
                value={this.state.regUser.salesforceSiteId}
                style={styles.searchBox}
                name="salesforceSiteId"
                placeholder={'Site ID'}
              />

              {this.state.salesforceStoreUrlValidation === 'error' ? (
                <p style={styles.spacerRed}>
                  One or more of your Salesforce Commerce API credentials are
                  invalid
                </p>
              ) : null}
            </Col>
          </Row>
          <Row style={{ textAlign: 'center', marginTop: 30 }}>
            <Col md={{ span: 6, offset: 3 }}>
              {this.state.salesforceStoreUrlValidation === null ||
              this.state.salesforceStoreUrlValidation === 'error' ? (
                <button style={styles.purpleButtonDisabled} disabled>
                  {'Connect with Salesforce Commerce'}
                </button>
              ) : (
                <Button
                  style={styles.purpleButton}
                  onClick={this.connectWithSalesforce}
                >
                  {'Connect with Salesforce Commerce'}
                </Button>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

LandingPageSalesforce.propTypes = {
  user: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  // sideBar: PropTypes.object.isRequired,
  appId: PropTypes.string,
};

function mapStateToProps(state: any) {
  return {
    user: state.user,
    nav: state.nav,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(userActions, dispatch),
    aActions: bindActionCreators(appActions, dispatch),
    nActions: bindActionCreators(navActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LandingPageSalesforce),
);
